import React from 'react'
import './setup'
import ReactDOM from 'react-dom/client'
import './index.css'
import '@blueprintjs/core/lib/css/blueprint.css'
import '@blueprintjs/popover2/lib/css/blueprint-popover2.css'
import reportWebVitals from './reportWebVitals'
import { Root } from './routes/root/Root'
import { HotkeysProvider } from '@blueprintjs/core'
import ErrorPage from './routes/root/ErrorPage'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const isValidRoute = window.location.pathname === '/'

root.render(
  <React.StrictMode>
    <HotkeysProvider>{isValidRoute ? <Root /> : <ErrorPage />}</HotkeysProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
